module.exports = __webpack_public_path__ + "static/media/dot_666666.c2d3a0d7.svg";